import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
//
import {
  HomeIcon,
  ShoppingCartIcon,
  BookOpenIcon,
  BellAlertIcon,
  Bars3Icon,
  XMarkIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ArchiveBoxArrowDownIcon,
  ArchiveBoxIcon,
  CurrencyDollarIcon,
  PaperAirplaneIcon,
  BanknotesIcon,
  ClipboardDocumentListIcon,
  CalculatorIcon,
  ShoppingBagIcon,
  TruckIcon,
  Cog6ToothIcon,
  SwatchIcon,
  BuildingStorefrontIcon,
  ArrowTrendingUpIcon,
  TableCellsIcon,
  CogIcon,
  ListBulletIcon,
  QueueListIcon,
  ShareIcon,
  UsersIcon,
  ChatBubbleLeftEllipsisIcon,
  TicketIcon,
  ChatBubbleBottomCenterTextIcon,
} from "@heroicons/react/24/outline";
import AdminInfoSection from "./AdminInfoSection";
import { useTranslation } from "react-i18next";

import BrandsSettings from "./settings/brands/BrandsSettings";
import SubCategoriesSettings from "./settings/subCategory/SubCategoriesSettings";
import CategoriesSettings from "./settings/Category/CategoriesSettings";
import ShoppingChoicesSettings from "./settings/Shopping Choices/ShoppingChoicesSettings";
import ServicesSettings from "./settings/Service/ServicesSettings";
import StoresSettings from "./settings/Store/StoresSettings";
import PendingCart from "./Pending Cart/Cart/PendingCart";
import PricedCart from "./Priced Cart/Cart/PricedCart";
import PurchasedCart from "./Purchased Cart/Cart/PurchasedCart";
import RequestedCart from "./Requested Cart/Cart/RequestedCart";
import ReceivedCart from "./Received Cart/Cart/ReceivedCart";
import PackedCart from "./Packed Cart/Cart/PackedCart";
import ShippedCart from "./Shipped Cart/Cart/ShippedCart";
import DeliveredCart from "./Delivered Cart/Cart/DeliveredCart";
import SelectBrandsSettings from "./settings/SelectBrands/SelectBrandsSettings";
import SubscribetSettings from "./settings/SubscribetSettings";
import { fetchAllCarts } from "../../redux/reducer/cartReducer";
import ShippingCompaniesSettings from "./Shipping Companies/ShippingCompaniesSettings";
import {
  getMenuItemscompaniesEurope,
  getMenuItemscompaniesTurkey,
} from "../../constent/companies";
import { useLocation } from "react-router-dom";
import FeedbackSettings from "./settings/Feedback/FeedbackSettings";
import ShowUsers from "./ShowUsers";
import ShowCoupon from "./Coupon/ShowCoupon";
import ShowTestimonials from "./testimonials/ShowTestimonials";
import ShopBrandsSettings from "./settings/Shop Brands/ShopBrandsSettings";

const SidebarAdmin = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState("HomeAdminSection");
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const { t } = useTranslation();

  const MenuItemscompaniesEurope = getMenuItemscompaniesEurope(t);
  const MenuItemscompaniesTurkey = getMenuItemscompaniesTurkey(t);

  useEffect(() => {
    dispatch(fetchAllCarts());
  }, [dispatch]);

  const handleMenuItemClick = (key) => {
    setSelectedMenuItem(key);
    setMenuOpen(false);
  };

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    switch (currentPath) {
      case "orders-placed":
        setSelectedMenuItem("OrdersByUsers");
        setOpenDropdowns((prev) => ({ ...prev, ProcurementClient: true }));
        break;
      case "priced-orders":
        setSelectedMenuItem("OrdersPriced");
        setOpenDropdowns((prev) => ({ ...prev, ProcurementClient: true }));
        break;
      case "purchased-orders":
        setSelectedMenuItem("OrdersPurchased");
        setOpenDropdowns((prev) => ({ ...prev, ProcurementClient: true }));
        break;
      case "incoming-orders":
        setSelectedMenuItem("OrdersRequest");
        setOpenDropdowns((prev) => ({ ...prev, ProcurementClient: true }));
        break;
      case "received-orders":
        setSelectedMenuItem("OrdersReceived");
        setOpenDropdowns((prev) => ({ ...prev, Packaging_Shipping: true }));
        break;
      case "packed-orders":
        setSelectedMenuItem("OrdersPacked");
        setOpenDropdowns((prev) => ({ ...prev, Packaging_Shipping: true }));
        break;
      case "shipped-orders":
        setSelectedMenuItem("OrdersShipped");
        setOpenDropdowns((prev) => ({ ...prev, Packaging_Shipping: true }));
        break;
      case "delivered-orders":
        setSelectedMenuItem("OrdersDelivered");
        setOpenDropdowns((prev) => ({ ...prev, Packaging_Shipping: true }));
        break;
      default:
        setSelectedMenuItem("HomeAdminSection");
    }
  }, [location]);

  const menuItems = [
    { label: t("HomeAdminSection"), icon: HomeIcon, key: "HomeAdminSection" },
    { label: t("Users"), icon: UsersIcon, key: "user" },
    { label: t("Coupon"), icon: TicketIcon, key: "coupon" },
    {
      label: t("ProcurementClient"),
      icon: ArchiveBoxArrowDownIcon,
      key: "ProcurementClient",
      hasDropdown: true,
      subItems: [
        {
          label: t("OrdersByUsers"),
          icon: ArchiveBoxIcon,
          key: "OrdersByUsers",
        },
        {
          label: t("Priced Orders"),
          icon: CurrencyDollarIcon,
          key: "OrdersPriced",
        },
        {
          label: t("Purchased Orders"),
          icon: BanknotesIcon,
          key: "OrdersPurchased",
        },
        {
          label: t("Incoming Orders"),
          icon: PaperAirplaneIcon,
          key: "OrdersRequest",
        },
      ],
    },
    {
      label: t("Packaging & Shipping"),
      icon: ShoppingCartIcon,
      key: "Packaging_Shipping",
      hasDropdown: true,
      subItems: [
        {
          label: t("Received Orders"),
          icon: ClipboardDocumentListIcon,
          key: "OrdersReceived",
        },
        {
          label: t("Packed Orders"),
          icon: ArchiveBoxArrowDownIcon,
          key: "OrdersPacked",
        },
        {
          label: t("Shipped Orders"),
          icon: ShoppingBagIcon,
          key: "OrdersShipped",
        },
        {
          label: t("Delivered Orders"),
          icon: TruckIcon,
          key: "OrdersDelivered",
        },
      ],
    },
    {
      label: t("Calculate Shipping"),
      icon: CalculatorIcon,
      key: "CalculateShipping",
      hasDropdown: true,
      subItems: [
        {
          label: t("Turkey Companies"),
          icon: QueueListIcon,
          key: "TurkeyCompanies",
        },
        {
          label: t("Europe Companies"),
          icon: QueueListIcon,
          key: "EuropeCompanies",
        },
      ],
    },
    {
      label: t("Settings"),
      icon: Cog6ToothIcon,
      key: "Settings",
      hasDropdown: true,
      subItems: [
        {
          label: t("Departments"),
          icon: SwatchIcon,
          key: "Department",
          hasDropdown: true,
          subItems: [
            {
              label: t("Home Page"),
              icon: CogIcon,
              key: "Home_Page",
              hasDropdown: true,
              subItems: [
                // {
                //   label: t("Shopping"),
                //   icon: BookOpenIcon,
                //   key: "ShoppingSettings",
                // },
                {
                  label: t("Shop brands"),
                  icon: BookOpenIcon,
                  key: "ShopBrandsSettings",
                },
                {
                  label: t("Turkey Brands"),
                  icon: ArrowTrendingUpIcon,
                  key: "Turkey_Brands",
                },
                {
                  label: t("Europen Brands"),
                  icon: ArrowTrendingUpIcon,
                  key: "Europen_Brands",
                },
                {
                  label: t("Stores"),
                  icon: BuildingStorefrontIcon,
                  key: "StoresSettings",
                },
              ],
            },
            {
              label: t("Categories"),
              icon: ListBulletIcon,
              key: "CategoriesSettings",
            },
            {
              label: t("SubCategories"),
              icon: QueueListIcon,
              key: "SubCategoriesSettings",
            },
            { label: t("Brands"), icon: TableCellsIcon, key: "BrandsSettings" },
            {
              label: t("Services"),
              icon: TableCellsIcon,
              key: "ServicesSettings",
            },
          ],
        },
        {
          label: t("Communication"),
          icon: ShareIcon,
          key: "Communication",
          hasDropdown: true,
          subItems: [
            { label: t("Subscribet"), icon: BellAlertIcon, key: "Subscribet" },
            {
              label: t("Testimonials"),
              icon: ChatBubbleBottomCenterTextIcon,
              key: "testimonials",
            },
            {
              label: t("Feedback"),
              icon: ChatBubbleLeftEllipsisIcon,
              key: "FeedbackSettings",
            },
          ],
        },
      ],
    },
  ];

  const [openDropdowns, setOpenDropdowns] = useState({});

  const handleDropdownToggle = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderMenuItems = (items, level = 0) => (
    <ul className={` space-y-2 ${level > 0 ? "ml-4" : ""}`}>
      {items.map((item) => (
        <div key={item.key} className="relative">
          <li
            className={`flex items-center justify-between px-2 py-2 text-black hover:bg-custom-gradient-div cursor-pointer ${
              selectedMenuItem === item.key ? "bg-custom-yellow font-bold" : ""
            }`}
            onClick={() => {
              if (item.hasDropdown) {
                handleDropdownToggle(item.key);
              } else {
                handleMenuItemClick(item.key);
              }
            }}
          >
            <div className="flex items-center gap-2 text-sm">
              <item.icon className="w-5 h-5" />
              {item.label}
            </div>
            {item.hasDropdown && (
              <span className="text-xs">
                {openDropdowns[item.key] ? (
                  <ChevronUpIcon className="w-5 h-5 text-black" />
                ) : (
                  <ChevronDownIcon className="w-5 h-5 text-black" />
                )}
              </span>
            )}
          </li>

          {item.hasDropdown && openDropdowns[item.key] && item.subItems && (
            <div className="mt-1">
              {renderMenuItems(item.subItems, level + 1)}
            </div>
          )}
        </div>
      ))}
    </ul>
  );

  const renderMenu = () => renderMenuItems(menuItems);

  return (
    <div className="relative flex-col md:flex" dir="ltr">
      <div className="w-full md:flex ">
        <div className="w-1/6">
          <div className="flex items-center justify-between p-4 md:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-black"
            >
              {menuOpen ? (
                <XMarkIcon className="w-6 h-6" />
              ) : (
                <Bars3Icon className="w-6 h-6" />
              )}
            </button>
          </div>

          <div
            className={`fixed top-0 left-0 z-50 w-1/2 h-full bg-white shadow-lg transform transition-all duration-300 ease-in-out ${
              menuOpen ? "translate-x-0" : "-translate-x-full"
            } md:hidden`}
          >
            {renderMenu()}
          </div>

          <div className="hidden md:block">
            <div className="flex flex-col w-full min-h-[75vh] p-2 pt-5 bg-white rounded-md shadow-md h-fit">
              {renderMenu()}
            </div>
          </div>
        </div>

        <div className="w-5/6 ">
          {selectedMenuItem === "HomeAdminSection" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <AdminInfoSection />
            </div>
          )}
          {selectedMenuItem === "user" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShowUsers />
            </div>
          )}
          {selectedMenuItem === "OrdersByUsers" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <PendingCart />
            </div>
          )}
          {selectedMenuItem === "coupon" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShowCoupon />
            </div>
          )}
          {selectedMenuItem === "OrdersPriced" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <PricedCart />
            </div>
          )}
          {selectedMenuItem === "OrdersPurchased" && (
            <div className="relative mt-5 md:mx-5 md:mt-10">
              <PurchasedCart />
            </div>
          )}
          {selectedMenuItem === "OrdersRequest" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <RequestedCart />
            </div>
          )}

          {selectedMenuItem === "OrdersReceived" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ReceivedCart />
            </div>
          )}
          {selectedMenuItem === "OrdersPacked" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <PackedCart />
            </div>
          )}
          {selectedMenuItem === "OrdersShipped" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShippedCart />
            </div>
          )}
          {selectedMenuItem === "OrdersDelivered" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <DeliveredCart />
            </div>
          )}

          {selectedMenuItem === "Users" && (
            <div className="mt-5 md:mx-5 md:mt-10">Coming Soon</div>
          )}

          {selectedMenuItem === "TurkeyCompanies" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShippingCompaniesSettings
                companies={MenuItemscompaniesTurkey}
                zone={{ en: "Turkey", ar: "تركيا" }}
              />
            </div>
          )}
          {selectedMenuItem === "EuropeCompanies" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShippingCompaniesSettings
                companies={MenuItemscompaniesEurope}
                zone={{ en: "Europe", ar: "أوروبا" }}
              />
            </div>
          )}

          {selectedMenuItem === "CategoriesSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <CategoriesSettings />
            </div>
          )}
          {selectedMenuItem === "SubCategoriesSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <SubCategoriesSettings />
            </div>
          )}
          {selectedMenuItem === "BrandsSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <BrandsSettings />
            </div>
          )}

          {/* {selectedMenuItem === "ShoppingSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShoppingChoicesSettings />
            </div>
          )} */}
          {selectedMenuItem === "ShopBrandsSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShopBrandsSettings />
            </div>
          )}
          {selectedMenuItem === "ServicesSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ServicesSettings />
            </div>
          )}
          {selectedMenuItem === "StoresSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <StoresSettings />
            </div>
          )}
          {selectedMenuItem === "FeedbackSettings" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <FeedbackSettings />
            </div>
          )}

          {selectedMenuItem === "Turkey_Brands" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <SelectBrandsSettings
                area="Turkey"
                areaID="67dfef4a100f542a2c700c04"
              />
            </div>
          )}
          {selectedMenuItem === "Europen_Brands" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <SelectBrandsSettings
                area="Europen"
                areaID="67dfef98100f542a2c700c08"
              />
            </div>
          )}

          {selectedMenuItem === "Subscribet" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <SubscribetSettings
                area="Europen"
                areaID="67dfef98100f542a2c700c08"
              />
            </div>
          )}
          {selectedMenuItem === "testimonials" && (
            <div className="mt-5 md:mx-5 md:mt-10">
              <ShowTestimonials />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarAdmin;
